import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormService } from 'app/services/form.service';

@Component({
  selector: 'app-oxygen-permeability',
  templateUrl: './oxygen-permeability.component.html',
  styleUrls: ['./oxygen-permeability.component.scss']
})
export class OxygenPermeabilityComponent implements OnInit {
  @ViewChild('oxygenPermeabilityAt35CInput') oxygenPermeabilityAt35CInput!: ElementRef;
  @ViewChild('oxygenPermeabilityInput') oxygenPermeabilityInput!: ElementRef;
  @ViewChild('oxygenMeanValueStdDeviationInput') oxygenMeanValueStdDeviationInput!: ElementRef;
  @ViewChild('oxygenNumberOfMeasurementsInput') oxygenNumberOfMeasurementsInput!: ElementRef;
  @ViewChild('methodUsedToDetermineOxygenPermeabilityInput') methodUsedToDetermineOxygenPermeabilityInput!: ElementRef;
  oxygenPermeabilityAt35C!: string;
  oxygenPermeability!: string;
  oxygenMeanValueStdDeviation!: string;
  oxygenNumberOfMeasurements!: string;
  methodUsedToDetermineOxygenPermeability!: string;

  constructor(private formService: FormService) {}

  ngOnInit(): void {
    this.oxygenPermeabilityAt35C = this.currentForm.get('oxygenPermeabilityAt35C')?.value;
    this.oxygenPermeability = this.currentForm.get('oxygenPermeability')?.value;
    this.oxygenMeanValueStdDeviation = this.currentForm.get('oxygenMeanValueStdDeviation')?.value;
    this.oxygenNumberOfMeasurements = this.currentForm.get('oxygenNumberOfMeasurements')?.value;
    this.methodUsedToDetermineOxygenPermeability = this.currentForm.get('methodUsedToDetermineOxygenPermeability')?.value;
  }

  public clearOxygenPermeabilityAt35CInputField() {
    this.oxygenPermeabilityAt35C = '';
    this.currentForm.patchValue({'oxygenPermeabilityAt35C': ''});
  }

  public clearOxygenPermeabilityInputField() {
    this.oxygenPermeability = '';
    this.currentForm.patchValue({'oxygenPermeability': ''});
  }

  public clearOxygenMeanValueStdDeviationInputField() {
    this.oxygenMeanValueStdDeviation = '';
    this.currentForm.patchValue({'oxygenMeanValueStdDeviation': undefined});
    this.errorCheck('oxygenMeanValueStdDeviation');
  }

  public clearMethodUsedToDetermineOxygenPermeabilityInputField() {
    this.methodUsedToDetermineOxygenPermeability = '';
    this.currentForm.patchValue({'methodUsedToDetermineOxygenPermeability': undefined});
    this.errorCheck('methodUsedToDetermineOxygenPermeability');
  }

  public clearOxygenNumberOfMeasurementsInputField() {
    this.oxygenNumberOfMeasurements = '';
    this.currentForm.patchValue({'oxygenNumberOfMeasurements': undefined});
    this.errorCheck('oxygenNumberOfMeasurements');
  }
  
  public updateOxygenPermeabilityAt35C(event: Event) {
    if(event && event.type === 'blur') {
      var target = document.activeElement;
      if(target && target.nodeValue === "cancel") {
        this.oxygenPermeabilityAt35C = '';
      }
    }
    this.currentForm.patchValue({'oxygenPermeabilityAt35C': this.oxygenPermeabilityAt35C});
  }
  
  public updateOxygenPermeability(event: Event) {
    if(event && event.type === 'blur') {
      var target = document.activeElement;
      if(target && target.nodeValue === "cancel") {
        this.oxygenPermeability = '';
      }
    }
    this.currentForm.patchValue({'oxygenPermeability': this.oxygenPermeability});
  }

  public updateOxygenMeanValueStdDeviation(event: Event) {
    if(event && event.type === 'blur') {
      var target = document.activeElement;
      if(target && target.nodeValue === "cancel") {
        this.oxygenMeanValueStdDeviation = '';
      }
    }
    this.currentForm.patchValue({'oxygenMeanValueStdDeviation': this.oxygenMeanValueStdDeviation});
    this.errorCheck('oxygenMeanValueStdDeviation');
  }

  public updateOxygenNumberOfMeasurements(event: Event) {
    if(event && event.type === 'blur') {
      var target = document.activeElement;
      if(target && target.nodeValue === "cancel") {
        this.oxygenNumberOfMeasurements = '';
      }
    }
    this.currentForm.patchValue({'oxygenNumberOfMeasurements': this.oxygenNumberOfMeasurements});
    this.errorCheck('oxygenNumberOfMeasurements');
  }

  public updateMethodUsedToDetermineOxygenPermeability(event: Event) {
    if(event && event.type === 'blur') {
      var target = document.activeElement;
      if(target && target.nodeValue === "cancel") {
        this.methodUsedToDetermineOxygenPermeability = '';
      }
    }
    this.currentForm.patchValue({'methodUsedToDetermineOxygenPermeability': this.methodUsedToDetermineOxygenPermeability});
    this.errorCheck('methodUsedToDetermineOxygenPermeability');
  }

  public cancelUpdateOxygenPermeabilityAt35C() {
    this.oxygenPermeabilityAt35C = this.currentForm.get('oxygenPermeabilityAt35C')?.value;
  }

  public cancelUpdateOxygenPermeability() {
    this.oxygenPermeability = this.currentForm.get('oxygenPermeability')?.value;
  }

  public cancelUpdateOxygenMeanValueStdDeviation() {
    this.oxygenMeanValueStdDeviation = this.currentForm.get('oxygenMeanValueStdDeviation')?.value;
    this.errorCheck('oxygenMeanValueStdDeviation');
  }

  public cancelUpdateOxygenNumberOfMeasurements() {
    this.oxygenNumberOfMeasurements = this.currentForm.get('oxygenNumberOfMeasurements')?.value;
    this.errorCheck('oxygenNumberOfMeasurements');
  }

  public cancelUpdateMethodUsedToDetermineOxygenPermeability() {
    this.methodUsedToDetermineOxygenPermeability = this.currentForm.get('methodUsedToDetermineOxygenPermeability')?.value;
    this.errorCheck('methodUsedToDetermineOxygenPermeability');
  }

  public hasError(errorType: string, formFieldName: string): boolean {
    const control = this.currentForm.get(formFieldName);
    if(!control?.touched && !control?.dirty) {
      return false;
    }

    return control ? control.hasError(errorType) : false;
  }

  private errorCheck(formFieldName: string) {
    const targetControl = this.currentForm.get(formFieldName);
    if(!targetControl) {
      return;
    }

    // Force re-validation
    setTimeout(() => {
      targetControl.markAsTouched();
      targetControl.markAsDirty();
      targetControl.updateValueAndValidity();
    });
  }

  get currentForm(): FormGroup {
    return this.formService.getCurrentUsanFormValue();
  }

  public hasFieldValidationError(fieldName: string, errorName?: string): boolean {
    return this.formService.hasFieldValidationError(fieldName, errorName);
  }
}
